import { Form, Input } from "decorator-form";
import { css } from "styled-components";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

/**
 * @author chills
 * @description reusable config for basic block styles. See {@link SubFormWidget}
 */

@Form({title: "Block Styles"})
export class BlockStylesConfig {

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor?: string;

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color?: string;

	@Input({type: InputType.BORDER, title: "Border"})
	public border?: string;

	@Input({type: InputType.BORDER_TOP, title: "Border Top"})
	public borderTop?: string;
	
	@Input({type: InputType.BORDER_RIGHT, title: "Border Right"})
	public borderRight?: string;
	
	@Input({type: InputType.BORDER_BOTTOM, title: "Border Bottom"})
	public borderBottom?: string;
	
	@Input({type: InputType.BORDER_LEFT, title: "Border Left"})
	public borderLeft?: string;

	@Input({type: InputType.BOX_SHADOW, title: "Box Shadow"})
	public boxShadow?: string;

	@Input({type: InputType.UNIT, title: "Border Radius"})
	public borderRadius?: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding?: string;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;

	@Input({type: InputType.BACKGROUND_IMAGE, title: "Background Image"})
	public backgroundImage?: string;

	@Input({type: InputType.OBJECT_FIT, title: "Background Fit"})
	public backgroundSize?: string;

	@Input({type: InputType.OBJECT_POSITION, title: "Background Position"})
	public backgroundPosition?: string;

	@Input({type: InputType.UNIT, title: "Max Width"})
	public maxWidth?: string;

	@Input({type: InputType.UNIT, title: "Min Width"})
	public minWidth?: string;

	@Input({type: InputType.UNIT, title: "Max Width"})
	public maxHeight?: string;

	@Input({type: InputType.UNIT, title: "Min Height"})
	public minHeight?: string;
}

// use this as your input type
export const blockStylesInput = SubFormWidget.registerForm(BlockStylesConfig);

// convert to TemplateStringArray for styled-components
export function toBlockCss(data: BlockStylesConfig) {
	
	return data ? css`
		background-color: ${data.backgroundColor};
		background-image: ${data.backgroundImage};
		background-position: ${data.backgroundPosition};
		background-size: ${data.backgroundSize};
		color: ${data.color};
		border: ${data.border} !important;
		border-top: ${data && data.borderTop && data.border && data.borderTop.includes("none") && !data.border.includes("none")? data.border :data.borderTop} !important;
		border-right: ${data && data.borderRight && data.border && data.borderRight.includes("none") && !data.border.includes("none")? data.border :data.borderRight} !important;
		border-bottom: ${data && data.borderBottom && data.border && data.borderBottom.includes("none") && !data.border.includes("none")? data.border :data.borderBottom} !important;
		border-left: ${data && data.borderLeft && data.border && data.borderLeft.includes("none") && !data.border.includes("none")? data.border :data.borderLeft} !important;
		box-shadow: ${data.boxShadow};
		border-radius: ${data.borderRadius} !important;
		padding: ${data.padding};
		margin: ${data.margin};
		max-width: ${data.maxWidth};
		min-width: ${data.minWidth};
		max-height: ${data.maxHeight};
		min-height: ${data.minHeight};
	` : undefined;
}



// WEBPACK FOOTER //
// ./src/common/views/common/BlockStylesConfig.ts